<table mat-table [dataSource]="dataSource" id="materials-table" matSort (matSortChange)="onSortChanged($event)">

  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <div (click)="$event.stopPropagation()">
        <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu"
          [matMenuTriggerData]="{ caller: getCaller('id') }" type="button">
          {{ 'commonPackagingFields.id' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('id'))">filter_alt</mat-icon>
        </button>
      </div>
    </th>
    <td mat-cell *matCellDef="let element"> {{element.id}} </td>
  </ng-container>

  <ng-container matColumnDef="tracking">
    <th mat-header-cell *matHeaderCellDef [hidden]="!displayTrackedColumn"></th>
    <td mat-cell *matCellDef="let element" [hidden]="!displayTrackedColumn">
      <mat-icon *ngIf="element.hasExternalTracking">track_changes</mat-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="tags">
    <th mat-header-cell *matHeaderCellDef>
      <div (click)="$event.stopPropagation()">
        <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.tagFilterMenu"
          [matMenuTriggerData]="{ caller: getCaller('tags'), possibleTags: getPossibleTags() }"
          type="button">
          {{ 'dataManagement.tags.titleTags' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('tags'))">filter_alt
          </mat-icon>
        </button>
      </div>
    </th>
    <td mat-cell *matCellDef="let element">
      <app-tag-directive [tags]="getTagsFromIds(element.associatedTagIdentifiers)" [maxDisplayed]="2">
      </app-tag-directive>
    </td>
  </ng-container>

  <ng-container matColumnDef="articleName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <div (click)="$event.stopPropagation()">
        <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu"
          [matMenuTriggerData]="{ caller: getCaller('articleName') }" type="button">
          {{ 'component.fields.articleName' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('articleName'))">filter_alt</mat-icon>
        </button>
      </div>
    </th>
    <td mat-cell *matCellDef="let element"> {{element.articleName}} </td>
  </ng-container>

  <ng-container matColumnDef="articleNumber">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <div (click)="$event.stopPropagation()">
        <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu"
          [matMenuTriggerData]="{ caller: getCaller('articleNumber') }" type="button">
          {{ 'component.fields.articleNumber' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('articleNumber'))">filter_alt</mat-icon>
        </button>
      </div>
    </th>
    <td mat-cell *matCellDef="let element"> {{element.articleNumber}} </td>
  </ng-container>

  <ng-container matColumnDef="creationTimestamp">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <div (click)="$event.stopPropagation()">
        <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.dateFilterMenu"
          [matMenuTriggerData]="{ caller: getCaller('creationTimestamp') }" type="button">
          {{ 'commonPackagingFields.creationDate' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('creationTimestamp'))">filter_alt
          </mat-icon>
        </button>
      </div>
    </th>
    <td mat-cell *matCellDef="let element">
      {{formatDateToString(element.creationTimestamp)}}
    </td>
  </ng-container>

  <ng-container matColumnDef="lastModificationTimestamp">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <div (click)="$event.stopPropagation()">
        <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.dateFilterMenu"
          [matMenuTriggerData]="{ caller: getCaller('lastModificationTimestamp') }" type="button">
          {{ 'commonPackagingFields.lastModificationDate' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('lastModificationTimestamp'))">filter_alt
          </mat-icon>
        </button>
      </div>
    </th>
    <td mat-cell *matCellDef="let element">
      {{formatDateToString(element.lastModificationTimestamp)}}
    </td>
  </ng-container>

  <ng-container matColumnDef="manufacturerName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <div (click)="$event.stopPropagation()">
        <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu"
          [matMenuTriggerData]="{ caller: getCaller('manufacturerName') }" type="button">
          {{ 'material.fields.manufacturer' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('manufacturerName'))">filter_alt
          </mat-icon>
        </button>
      </div>
    </th>
    <td mat-cell *matCellDef="let element"> {{element.manufacturerName}} </td>
  </ng-container>

  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef>
      <span class="header-text">{{ 'dataManagement.actions' | transloco }}</span>
    </th>
    <td mat-cell *matCellDef="let element">
      <button *ngIf="!isRecyclingBinSelected" mat-icon-button (click)="navigateToMaterial(element)"
        matTooltip="{{ 'material.editMaterial' | transloco }}" type="button">
        <mat-icon>edit</mat-icon>
      </button>
      <button mat-icon-button (click)="deletePackagingPart([element.id])"
        matTooltip="{{ 'material.deleteMaterial' | transloco }}" type="button">
        <mat-icon>delete_forever</mat-icon>
      </button>
    </td>
  </ng-container>

  <ng-container matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef>
      <div (click)="$event.stopPropagation()">
        <button mat-button class="filter-button" (click)="selectAllMaterials()" type="button">
          {{ 'common.buttons.selectAll' | transloco }} <br> ({{selectedMaterialIds.length}}
          {{ 'common.text.selected' | transloco }})
        </button>
      </div>
    </th>
    <td mat-cell *matCellDef="let element"
      [matTooltipDisabled]="element.isValidForComponent == null || element.isValidForComponent === true"
      matTooltip="{{ 'material.tooltips.materialNotValidForComponent' | transloco }}">
      <mat-checkbox [checked]="isMaterialSelected(element)" (change)="setMaterialSelected($event.checked, element)"
        [disabled]="element.isValidForComponent != null && element.isValidForComponent === false">
      </mat-checkbox>
    </td>
  </ng-container>

  <ng-container matColumnDef="subRequestStatus">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <button mat-button class="filter-button" type="button"
        (click)="$event.stopPropagation()"
        [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
        [matMenuTriggerData]="{ caller: getCaller('subRequestStatus'), categories: getStatusOptions() }">
        {{ 'dataManagement.dataExchangeRequests.columns.status' | transloco }}
        <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('subRequestStatus'))">filter_alt</mat-icon>
      </button>
    </th>
    <td mat-cell *matCellDef="let element">{{ getSubRequestStatusLabel(statusMap?.get(element.id)) | transloco }}</td>
  </ng-container>

  <ng-container matColumnDef="showSubRequestComments">
    <th mat-header-cell *matHeaderCellDef style="width: 48px"></th>
    <td mat-cell *matCellDef="let element" style="width: 48px">
      <button mat-icon-button type="button" (click)="showSubRequestComments.emit(element.id); $event.stopPropagation()">
        <mat-icon
          [matBadge]="commentCountMap?.get(element.id)"
          [matBadgeHidden]="!commentCountMap?.get(element.id)"
          matBadgeColor="primary"
          matBadgeSize="small">comment</mat-icon>
      </button>
    </td>
  </ng-container>

  <ng-container matColumnDef="navigateToSubRequest">
    <th mat-header-cell *matHeaderCellDef style="width: 48px"></th>
    <td mat-cell *matCellDef="let element" style="width: 48px">
      <button [disabled]="statusMap?.get(element.id) === DataExchangeRequestStatusDto.Deleted" mat-icon-button type="button"
        [title]="'dataManagement.dataExchangeRequests.actions.openSubRequest' | transloco"
        (click)="navigateToSubRequest.emit(element.id); $event.stopPropagation()">
        <mat-icon>open_in_new</mat-icon>
      </button>
    </td>
  </ng-container>

  <ng-container matColumnDef="approveSubRequest">
    <th mat-header-cell *matHeaderCellDef style="width: 100px;text-align: center;">{{ 'dataManagement.actions' | transloco }}</th>
    <td mat-cell *matCellDef="let element" style="width: 148px">
      <button mat-icon-button type="button" [disabled]="statusMap?.get(element.id) !== DataExchangeRequestStatusDto.Submitted"
        [title]="'dataManagement.dataExchangeRequests.actions.approveSubRequest' | transloco"
        (click)="approveSubRequest.emit(element.id); $event.stopPropagation()">
        <mat-icon>check_circle</mat-icon>
      </button>
      <button mat-icon-button type="button" [disabled]="statusMap?.get(element.id) !== DataExchangeRequestStatusDto.Submitted"
        [title]="'dataManagement.dataExchangeRequests.actions.reopenSubRequest' | transloco"
        (click)="reopenSubRequest.emit(element.id); $event.stopPropagation()">
        <mat-icon>replay</mat-icon>
      </button>
      <button mat-icon-button type="button" [disabled]="statusMap?.get(element.id) === DataExchangeRequestStatusDto.Deleted"
        [title]="'dataManagement.dataExchangeRequests.actions.withdrawSubRequest' | transloco"
        (click)="withdrawSubRequest.emit(element.id); $event.stopPropagation()">
        <mat-icon>undo</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  <app-filter-menu #filterComponent="columnFilterComponent" [dataSource]="dataSource"></app-filter-menu>
</table>

<div class="loading-overlay" *ngIf="isLoading | async">
    <mat-spinner diameter="48" color="accent"></mat-spinner>
</div>

<mat-paginator *ngIf="isPaginatorVisible" [length]="1"
            [pageSize]="10"
            [pageSizeOptions]="[5, 10, 25, 100]"
            aria-label="Select page"
            (page)="onPageChanged($event)">
</mat-paginator>
